var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  fillRule: "evenodd",
  d: "M11.02 13.586V2.465h2v11.12l4.293-4.292 1.414 1.414-6.707 6.707-6.707-6.707 1.414-1.414zm9 5.414v2h-16v-2z",
  clipRule: "evenodd"
})));
export default SvgDownload;